
import './userBasicProfileV3.css';
import UserAvatar from 'components/userAvatar'
import React, { useEffect, useRef, useState } from 'react'
import PhoneInput from "react-phone-number-input";
import { Input, Select } from 'antd';
import UserRoleSelectV3 from './userRoleSelectV3';
import UserBasicInfo from './userBasicInfoV3';
import UserCurrentAddressV3 from './userCurrentAddressV3';
import UserEmergencyContactV3 from './userEmergencyContactV3';
import { Api } from 'services'
import { updateStaffProfile, uploadStaffPhoto, deleteStaffPhoto } from 'actions/userManagementV3';
import { connect } from 'react-redux';
import PageHeader from 'components/pageHeader';
import { useHistory, useLocation } from 'react-router';
import { Button } from 'components/Button';
import PageDataLoader from 'components/pageDataLoader';
import SaveUserBasicProfileV3 from 'pages/profile/saveUserBasicProfileV3';
import moment from 'moment';
import UserProfilePicChangeModal from '../userManagementV2/userProfilePicChangeModal';

// No photo (null/undefined/"default.png") -> empty string, so UserAvatar
// falls back to the name's initials instead of trying to load a broken
// ".../undefined" or ".../default.png" URL.
const resolveStaffImageUrl = (image) => {
    if (!image || image === "default.png") return "";
    // blob: URLs are the local object-URL preview of a not-yet-uploaded
    // pick (see storeImageFile) — already a full, directly-usable URL.
    if (image.startsWith("http") || image.startsWith("blob:")) return image;
    return `${Api._s3_url}${image}`;
};

const mobileRegex = /^[6-9]\d{9}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Normalizes `role` (a bare string right after load, an array once the user
// touches UserRoleSelectV3) so the initial-load snapshot and the live
// snapshot serialize identically when nothing has actually changed.
const buildProfileSnapshot = (values) => JSON.stringify({
    ...values,
    role: Array.isArray(values.role) ? values.role : (values.role ? [values.role] : []),
});

const UserEditProfileV3 = ({ userProfileDetailsV3, userDetails, userRowDetails, updateStaffProfile, uploadStaffPhoto, deleteStaffPhoto }) => {

    const bodyStyle = {
        backgroundColor: "#FAFAFA",
        width: " calc(100% + 30px)",
        height: "calc(100% + 40px)",
        margin: "-20px",
        padding: "20px 20px 15px 20px",
        // overflow: "auto"
    }

    const history = useHistory()
    const location = useLocation();
    // Where Cancel/Save/the back arrow return to. Defaults to the old
    // /user-management/profile (userProfileV3.js's own "EDIT PROFILE" button
    // doesn't pass a returnTo) — StaffProfilePage.js's EDIT button passes
    // returnTo: "/user-management/staff-profile" so coming back from an edit
    // started there doesn't land back on the old page instead.
    const returnTo = location?.state?.key?.returnTo || (location.pathname.startsWith('/user-management-v2') ? '/user-management-v2/profile' : '/user-management/profile');
    const inputProfilePic = useRef(null);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState([]);
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');
    const [blood, setBlood] = useState('');
    const [designation, setDesignation] = useState('');
    const [emergencyName, setEmergencyName] = useState('');
    const [emergencyContact, setEmergencyContact] = useState('');
    const [relationship, setRelationShip] = useState('');
    const [currentAddress, setCurrentAddress] = useState({ city: '', country: '', h_no: '', pincode: '', state: '' });
    const [permanentAddress, setPermanentAddress] = useState({ city: '', country: '', h_no: '', pincode: '', state: '' });
    const [isCreateBtnLoading, setCreateBtnLoading] = useState(false);
    const [pageLoader, togglePageLoader] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [profilePicModal, setProfilePicModal] = useState(false);
    const [flag, setFlag] = useState(false);
    const [imgUrl, setImgUrl] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [tempImage, setTempImage] = useState(userProfileDetailsV3?.image)
    // Picking/removing a photo no longer hits the API right away — it's
    // staged here and only sent (uploadStaffPhoto/deleteStaffPhoto) when
    // the user actually clicks SAVE, same moment updateStaffProfile fires.
    const [pendingPhotoRemoval, setPendingPhotoRemoval] = useState(false)
    const [privilege, setPrivilege] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [initialSnapshot, setInitialSnapshot] = useState(null);
    const chevron = require('../../Assets/userManagementV3/chevron.png').default

    useEffect(() => {
        console.log("userProfileDetailsV3", userProfileDetailsV3);
        if (userProfileDetailsV3) {
            const nextName = userProfileDetailsV3.name ?? "";
            const nextPhone = userProfileDetailsV3.phone ?? "";
            const nextRole = userProfileDetailsV3.role ?? "";
            const nextEmail = userProfileDetailsV3.email ?? "";
            const nextDesignation = userProfileDetailsV3.designation ?? "";
            const nextDob = userProfileDetailsV3.dob ?? "";
            const nextGender = userProfileDetailsV3.gender ?? "";
            const nextBlood = userProfileDetailsV3.bloodGroup ?? "";
            const nextCurrentAddress = JSON.parse(userProfileDetailsV3.currentAddress || "{}");
            const nextPermanentAddress = JSON.parse(userProfileDetailsV3.permanentAddress || "{}");
            const nextEmergencyContact = parseEmergencyPhone(userProfileDetailsV3.emergencyPhone ?? "");
            const nextRelationship = parseValue(userProfileDetailsV3.relationship ?? "");
            const nextEmergencyName = parseValue(userProfileDetailsV3.emergencyContactName ?? "");
            const nextPrivilege = userProfileDetailsV3.privilage ?? [];
            const nextEmployeeId = userProfileDetailsV3.attendanceEmpCode ?? "";

            setName(nextName);
            setPhone(nextPhone);
            setRole(nextRole);
            setEmail(nextEmail);
            setDesignation(nextDesignation);
            setDob(nextDob);
            setGender(nextGender);
            setBlood(nextBlood);
            setCurrentAddress(nextCurrentAddress);
            setPermanentAddress(nextPermanentAddress);
            setEmergencyContact(nextEmergencyContact);
            setRelationShip(nextRelationship);
            setEmergencyName(nextEmergencyName);
            setPrivilege(nextPrivilege);
            setEmployeeId(nextEmployeeId);

            // Baseline for the Save-button dirty-check below — built from the
            // exact same transformed values just used to seed local state, so
            // "nothing changed yet" compares equal right after load.
            setInitialSnapshot(buildProfileSnapshot({
                name: nextName, phone: nextPhone, email: nextEmail, role: nextRole,
                dob: nextDob, gender: nextGender, blood: nextBlood, designation: nextDesignation,
                emergencyName: nextEmergencyName, emergencyContact: nextEmergencyContact,
                relationship: nextRelationship, currentAddress: nextCurrentAddress,
                permanentAddress: nextPermanentAddress, privilege: nextPrivilege,
                employeeId: nextEmployeeId,
            }));
        }
    }, [userProfileDetailsV3]);

    // "REMOVE PROFILE PHOTO" confirm — just stages the removal locally now;
    // deleteStaffPhoto only actually fires from handleSaveClick below.
    const onDeleteConfirm = (callback, successCallback) => {
        setPendingPhotoRemoval(true);
        setTempImage(null);
        setImageFile(null);
        setImgUrl(null);
        if (inputProfilePic.current) inputProfilePic.current.value = null;
        successCallback();
        callback();
    }

    const handleProfileModalOk = () => {
        inputProfilePic?.current?.click();
    };

    // "YES" confirm inside UserProfilePicChangeModal after picking a file —
    // stages the pick locally (imageFile/imgUrl are already set by
    // storeImageFile/the modal itself) instead of uploading immediately;
    // uploadStaffPhoto only actually fires from handleSaveClick below.
    const handleConfirmPhotoChoice = (callback, buttonCallback) => {
        setPendingPhotoRemoval(false); // picking a new photo overrides a pending removal
        callback?.();
        buttonCallback?.();
    };

    const handleSaveClick = (callback, buttonCallback) => {
        togglePageLoader(true)
        setCreateBtnLoading(true);

        // Matches the actual PATCH /userv2/staff/:id contract. No `image`/
        // `file` here — photo goes through its own POST/DELETE
        // /staff/:id/photo endpoints, fired below once this PATCH succeeds.
        // privilages/permissions are part of the contract but intentionally
        // left out for now.
        const rawParams = {
            name,
            phone,
            email,
            roles: Array.isArray(role) ? role : (role ? [role] : []),
            designation,
            dob: dob ? moment(dob).format("YYYY-MM-DD") : null,
            gender,
            bloodGroup: blood,
            employeeId,
            currentHouseNo: currentAddress?.h_no,
            currentDistrict: currentAddress?.city,
            currentState: currentAddress?.state,
            currentCountry: currentAddress?.country,
            currentPincode: currentAddress?.pincode,
            permanentHouseNo: permanentAddress?.h_no,
            permanentDistrict: permanentAddress?.city,
            permanentState: permanentAddress?.state,
            permanentCountry: permanentAddress?.country,
            permanentPincode: permanentAddress?.pincode,
            emergencyContactName: emergencyName,
            emergencyContactPhone: emergencyContact,
            emergencyContactRelationship: relationship,
        };

        // Enum-backed fields (designation/gender/bloodGroup) and roles get
        // sent as "" / [] when the user hasn't touched them yet — the backend
        // likely rejects those with a 400 rather than treating them as "no
        // change", so leave them out of the PATCH entirely instead of null.
        const params = Object.fromEntries(
            Object.entries(rawParams).filter(([, value]) => (
                value !== "" && value !== null && value !== undefined
                && !(Array.isArray(value) && value.length === 0)
            ))
        );

        const finishSave = () => {
            onSaveSuccess(callback);
            buttonCallback?.();
        };

        updateStaffProfile(userRowDetails?.id, params, () => {
            if (imageFile) {
                uploadStaffPhoto(userRowDetails?.id, imageFile, (percent, response) => {
                    if (percent === 100) {
                        const updatedImage = response?.data?.image ?? response?.image;
                        if (updatedImage) setTempImage(updatedImage);
                        setImageFile(null);
                        setImgUrl(null);
                        finishSave();
                    }
                });
            } else if (pendingPhotoRemoval) {
                deleteStaffPhoto(userRowDetails?.id, () => {
                    setPendingPhotoRemoval(false);
                    finishSave();
                });
            } else {
                finishSave();
            }
        });
    }

    const storeImageFile = (file) => {
        setImageFile(file)
    }

    // Stripping the "+91"/"91" country-code prefix off the FRONT (not
    // slice(-10) off the end) matters while the number is still being typed:
    // the total digit count (country code + partial national number) can
    // coincidentally equal 10 before the national number itself is actually
    // 10 digits (e.g. "91" + 8 digits = 10), so taking the last 10 digits can
    // grab part of the country code as if it were the number and pass by
    // accident. Stripping the known prefix instead always leaves the real
    // national number, whatever its current length.
    const mobileDigits = (phone || '').startsWith('+91') ? phone.slice(3)
        : (phone || '').startsWith('91') ? phone.slice(2)
        : (phone || '').replace(/\D/g, '');
    const mobileError = !mobileRegex.test(mobileDigits);
    const emailError = !!email && !emailRegex.test(email);
    const hasValidationErrors = mobileError || emailError;

    const currentSnapshot = buildProfileSnapshot({
        name, phone, email, role, dob, gender, blood, designation,
        emergencyName, emergencyContact, relationship, currentAddress,
        permanentAddress, privilege, employeeId,
    });
    // Disabled on first render (initialSnapshot not loaded yet), disabled
    // while nothing differs from what was loaded, and disabled on a
    // validation error — SAVE only lights up once there's a real, valid change.
    // A staged photo pick/removal counts as a change too, since that's now
    // also only persisted (uploadStaffPhoto/deleteStaffPhoto) on Save.
    const hasPendingPhotoChange = !!imageFile || pendingPhotoRemoval;
    const hasChanges = (initialSnapshot !== null && currentSnapshot !== initialSnapshot) || hasPendingPhotoChange;
    const isSaveDisabled = !hasChanges || hasValidationErrors;

    const actions = [
        <Button loading={isCreateBtnLoading} type="primary"
            style={{ marginRight: 20, backgroundColor: "#FFFFFF", color: "#594099" }}
            onClick={() => {
                clearValues()
                setFlag(false)
                history.push({
                    pathname: returnTo,
                    state: {
                        key: true,
                    }
                })
            }}
        >RESET</Button>,
        <Button
            loading={isCreateBtnLoading}
            disabled={isSaveDisabled}
            type="primary"
            onClick={() => {
                setFlag(false)
                setShowConfirmModal(true)
            }}
        >
            {"SAVE"}</Button>
    ]


    const onSaveSuccess = (callback) => {
        callback();
        setCreateBtnLoading(false)
        togglePageLoader(false)
        history.push({
            pathname: returnTo,
            state: {
                key: true,
            }
        })
    }


    const clearValues = () => {

    }

    const parseEmergencyPhone = (phone) => {
        try {
            return JSON.parse(phone);
        } catch (e) {
            return phone;
        }
    };

    const parseValue = (value) => {
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    };


    const handlePhoneChange = (value) => {
        setPhone(value);
    };

    const roles = [
        { value: "Teacher", label: "Teacher" },
        { value: "Operation", label: "Operations" },
        // { value: "Data Operator", label: "Data Operator" }
    ];
    const privilegeOptions = [
        {
            label: "Admin", value: "Admin",
            disabled: userDetails?.privilage?.includes("Admin") && !userDetails?.privilage?.includes("SuperAdmin"),
        },
        {
            label: "Planner", value: "Planner",
            disabled: privilege.includes("Admin"),
        },
        {
            label: "Fee Manager", value: "FeeManager",
        },
        {
            label: "Leave Manager", value: "LeaveManager",
        },
        {
            label: "Institute Support", value: "InstituteSupport",
            disabled: privilege.includes("Admin"),
        },
        {
            label: "Attendance Marker", value: "AttendanceMarker",
            disabled: privilege.includes("Admin") || privilege.includes("Planner"),
        },
        {
            label: "Marketing", value: "Marketing",
        },
    ];

    return (
        <div style={{ ...bodyStyle, }}>
            <div style={{ marginBottom: "45px" }}>
                <PageHeader
                    fromUserProfileV3={true}
                    onBackPress={() => {
                        history.push({
                            pathname: returnTo,
                            state: {
                                key: true,
                            }
                        })
                    }}
                    title={`Edit ${userProfileDetailsV3?.name}'s profile`}
                    actions={actions}
                />
            </div>
            <div className='user-edit-profile-v3' style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <div className="profile-container" style={{ height: 'auto', display: 'flex', flexDirection: 'column' }}>
                    <div className="profile-inner" style={{ flex: 1, height: 'auto' }}>
                        <div>
                            <div className="profile-pic-container">
                                <div className='user-profile-pic-v3' style={{ width: '100%', padding: '0 22px' }}>
                                    <UserAvatar
                                        size={220}
                                        shape="square"
                                        name={userProfileDetailsV3?.name}
                                        img={resolveStaffImageUrl(imgUrl || tempImage)}
                                        fontWeight={true}
                                        userEditProfile={true}
                                    />
                                    <div
                                        className='change-profile-pic'
                                        onClick={() => {
                                            setProfilePicModal(true);
                                        }}
                                    >
                                        CHANGE PROFILE PHOTO
                                    </div>
                                </div>
                            </div>
                            <div className='profile-pic-label'>
                                <label className="profile-pic-name-label">Name</label>
                                <Input
                                    bordered={null}
                                    className='user-profile-name-v3 profile-name-input'
                                    inputId={"-998"}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>

                            <div className='mobile-label'>
                                <label className="profile-pic-name-label">Mobile No.</label>
                                <PhoneInput
                                    className="PhoneInputV3"
                                    bordered={null}
                                    defaultCountry="IN"
                                    placeholder={"Enter mobile number"}
                                    height={"40px"}
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    style={{ border: 'none', borderBottom: '1px solid #E6E6E6' }}
                                    maxLength={phone?.startsWith('+91') && phone?.length === 13 ? 11 : ""}
                                    addInternationalOption={true}
                                />
                                {mobileError && (
                                    <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>Enter a valid 10-digit mobile number</div>
                                )}
                            </div>

                            <div className='role-label'>
                                <label className="profile-pic-name-label">Role</label>
                                <UserRoleSelectV3
                                    roles={roles}
                                    role={role}
                                    setRole={setRole}
                                />
                            </div>
                            <div className="privilege-label">
                                <label className="profile-pic-name-label">Privilege</label>

                                <Select
                                    mode="multiple" showArrow
                                    className="no-border-select-v3"
                                    style={{ width: "100%", border: "none" }}
                                    value={privilege}
                                    onChange={setPrivilege}
                                    options={privilegeOptions}
                                    suffixIcon={<img src={chevron} alt="icon" />}
                                    maxTagCount={0}
                                    maxTagPlaceholder={() => (
                                        <span
                                        // style={{
                                        //     display: "inline-block",
                                        //     // maxWidth: "calc(100% - 24px)",
                                        //     overflow: "hidden",
                                        //     textOverflow: "ellipsis",
                                        //     whiteSpace: "nowrap",
                                        // }}
                                        >
                                            {privilegeOptions
                                                .filter(item => privilege.includes(item.value))
                                                .map(item => item.label)
                                                .join(", ")}
                                        </span>)
                                    }
                                    showSearch={false}
                                />
                            </div>
                            <div className='role-label'>
                                <label className="profile-pic-name-label">Employee ID</label>
                                <input
                                    type="text"
                                    value={employeeId}
                                    onChange={(e) => setEmployeeId(e.target.value)}
                                    className="profile-name-input"
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div style={{ width: '77%', height: 'auto' }}>
                    <div style={{ width: '100%', height: 'auto' }}>
                        <UserBasicInfo
                            userProfileDetailsV3={userProfileDetailsV3}
                            email={email}
                            setEmail={setEmail}
                            emailError={emailError}
                            setDesignation={setDesignation}
                            designation={designation}
                            dob={dob}
                            setDob={setDob}
                            blood={blood}
                            setBlood={setBlood}
                            gender={gender}
                            setGender={setGender}
                        />
                    </div>
                    <div style={{ width: '100%', height: 'auto' }}>
                        <UserCurrentAddressV3
                            userProfileDetailsV3={userProfileDetailsV3}
                            setCurrentAddress={setCurrentAddress}
                            currentAddress={currentAddress}
                            current={true}
                        />
                    </div>
                    <div style={{ width: '100%', height: 'auto' }}>
                        <UserCurrentAddressV3
                            userProfileDetailsV3={userProfileDetailsV3}
                            setPermanentAddress={setPermanentAddress}
                            permanentAddress={permanentAddress}
                            current={false}
                        />
                    </div>
                    <div style={{ width: '100%', height: 'auto', }}>
                        <UserEmergencyContactV3
                            emergencyName={emergencyName}
                            setEmergencyName={setEmergencyName}
                            emergencyContact={emergencyContact}
                            setEmergencyContact={setEmergencyContact}
                            relationship={relationship}
                            setRelationShip={setRelationShip}
                        />
                    </div>

                </div>
            </div>
            <SaveUserBasicProfileV3
                saveConfirmationModal={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                handleOk={(callback, buttonCallback) => handleSaveClick(callback, buttonCallback)}
                setFlag={setFlag}
                flag={flag}
                onDeleteConfirm={(callback, successCallback) => onDeleteConfirm(callback, successCallback)}
            />

            <UserProfilePicChangeModal
                showModal={profilePicModal}
                setProfilePicModal={setProfilePicModal}
                setShowConfirmModal={setShowConfirmModal}
                setFlag={setFlag}
                handleOk={handleProfileModalOk}
                src={tempImage}
                ref={inputProfilePic}
                setfileInputValue={(file) => storeImageFile(file)}
                handleCancel={() => setProfilePicModal(false)}
                onOk={(callback, buttonCallback) => handleConfirmPhotoChoice(callback, buttonCallback)}
                setImgUrl={setImgUrl}
                imgUrl={imgUrl}
                imageFile={imageFile}
                setImageFile={setImageFile}
            />
            <PageDataLoader visible={pageLoader} />
        </div>

    )
}

const mapStateToProps = (state) => {
    const { userProfileDetailsV3, userRowDetails } = state.userManagementV2
    const { userDetails } = state.profileNew;
    return {
        userProfileDetailsV3, userDetails, userRowDetails
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateStaffProfile: (id, params, callback) => dispatch(updateStaffProfile(id, params, callback)),
    uploadStaffPhoto: (id, file, callback) => dispatch(uploadStaffPhoto(id, file, callback)),
    deleteStaffPhoto: (id, callback) => dispatch(deleteStaffPhoto(id, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserEditProfileV3);
